export const FEED_ENTRY_POINT = "feed-entry-point-event";
